import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useDispatchTrackErrorEvent } from '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/state';
import '../../../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import { CheckoutErrorsMapping } from '../../../../../mappers/errors-mapping.js';
import '../../../../../utils/get-customer-details-payload.js';
import '../../../../../models/cart/cart-state.js';
import '../../../../../models/checkout/checkout-step-error-type.js';
import '../../../../../models/checkout-settings.js';
import '../../../../../models/step-shipping/shipping-methods.js';
import '../../../../../models/shared.js';
import 'history';
import '../../../../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../../../../context/CheckoutSettings/context.js';
import '../../../../../selectors.js';
import { useMutationConfig } from '../../../../../hooks/operations/use-mutation-config.js';
import '@grandvisionhq/lib-utils-cart';
import '../../../../../operations/mutations/set-customer-details.js';
import '../../../../../operations/mutations/set-service-store.js';
import '../../../../../operations/mutations/set-shipping-method.js';
import '../../../../../operations/mutations/set-shipping-state.js';
import { CREATE_APPLE_PAY_SESSION } from '../../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../../operations/fragments/paypal-payment.js';
import '../../../../../operations/fragments/saved-user-details.js';
import '../../../../../operations/queries/get-checkout-state.js';
import '../../../../../operations/queries/get-user-details.js';

const useCreateApplePaySession = ({ onError , onCompleted ,  } = {})=>{
    var ref5, ref1, ref2, ref3;
    const [session1, setSession] = React.useState(null);
    const { mutationOptions  } = useMutationConfig({
        onError,
        onCompleted
    });
    const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
    const [mutationCallback, mutation] = useMutation(CREATE_APPLE_PAY_SESSION, mutationOptions);
    React.useEffect(()=>{
        var ref, ref4;
        const merchantSessionData = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.data) === null || ref === void 0 ? void 0 : (ref4 = ref.createApplePaySession) === null || ref4 === void 0 ? void 0 : ref4.data;
        if (session1 && merchantSessionData) {
            const decodedMerchantSession = atob(merchantSessionData);
            const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
            try {
                session1.completeMerchantValidation(decodedAndParsedMerchantSession);
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                    console.error(e);
                    toast.failed(CheckoutErrorsMapping.SomethingWentWrong);
                    dispatchTrackErrorEvent(()=>Promise.resolve({
                            Error_Source: 'Server',
                            Error_Code: 'Create apple pay session error',
                            Error_Details: CheckoutErrorsMapping.SomethingWentWrong,
                            Error_Message: e instanceof Error ? e.message : ''
                        })
                    );
                    throw e;
                }
            }
        }
    // To avoid extra re-render due to dispatchTrackErrorEvent
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        session1,
        mutation === null || mutation === void 0 ? void 0 : (ref5 = mutation.data) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.createApplePaySession) === null || ref1 === void 0 ? void 0 : ref1.data,
        mutation === null || mutation === void 0 ? void 0 : (ref2 = mutation.data) === null || ref2 === void 0 ? void 0 : ref2.createApplePaySession,
        mutation === null || mutation === void 0 ? void 0 : mutation.data, 
    ]);
    // The domainName should be always determined likes this. Therefore exposing it as a variable is unnecessary.
    const domainName = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.hostname);
    const createApplePaySession = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(session) {
            setSession(session);
            yield mutationCallback({
                variables: {
                    applePaySessionInput: {
                        domainName
                    }
                }
            });
        });
        return function(session) {
            return _ref.apply(this, arguments);
        };
    }(), [
        domainName,
        mutationCallback
    ]);
    return {
        createApplePaySession,
        isLoading: mutation.loading,
        updateError: mutation.error
    };
};

export { useCreateApplePaySession };
//# sourceMappingURL=use-create-apple-pay-session.js.map
